import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import constant from '../../constant';
import DeviceForm from '../ui/deviceForm';

const AddDevice = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancel = () => {
    navigate('/admin/alldevices');
  };

  const handleSubmit = async (deviceData) => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        return;
      }

      const apiData = {
        device_name: deviceData.device_name,
        mac_address: deviceData.device_mac,
      };

      const response = await fetch(`${constant.REACT_APP_API_URL}/device/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiData),
      });

      const result = await response.json();
      if (response.ok) {
        navigate('/admin/alldevices');
      } else {
        setError(result.message || 'Failed to add device');
      }
    } catch (error) {
      setError('Error adding device');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6 pt-20 md:pt-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-center space-x-4">
            <button onClick={handleBack} className="text-gray-500 hover:text-gray-700 transition-colors">
              <ArrowLeft className="h-6 w-6" />
            </button>
            <h2 className="text-2xl font-bold text-gray-800">Add Device</h2>
          </div>
        </div>
        {loading && (
          <div className="bg-blue-50 text-blue-700 p-4 rounded-lg mb-6">
            Processing...
          </div>
        )}
        {error && (
          <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6">
            {error}
            <button
              onClick={() => setError(null)}
              className="ml-4 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
            >
              Clear Error
            </button>
          </div>
        )}
        <DeviceForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isEditMode={false}
        />
      </div>
    </div>
  );
};

export default AddDevice;